import { useState, useEffect, useRef } from "react";
import QuadralButton from '@quadral/quadral-component-common/dist/components/button';
import QuadralModal from '@quadral/quadral-component-common/dist/components/modal';
import QuadralAutocomplete from "@quadral/quadral-component-common/dist/components/autocomplete";
import QuadralForm from "@quadral/quadral-component-common/dist/components/form"
import QuadralTextField from "@quadral/quadral-component-common/dist/components/textField"
import QuadralDate from "@quadral/quadral-component-common/dist/components/date"
import QuadralTypography from "@quadral/quadral-component-common/dist/components/typography";
import Grid from '@mui/material/Grid';
import { faFloppyDisk, faUserPen } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { onlineProcessesService } from "../../services";

const UpdatePersonModal = ({open, setOpen, setLoader, showLoader, hideLoader, Loader, participation, selectedPerson, mapReferenceToOptions, quadralToast, isN3, ...props}) => {

    const [initialPersonData, setInitialPersonData] = useState({});
    const [valueBirthCity, setValueBirthCity] = useState("");
    const [resultBirthCity, setResultBirthCity] = useState(null);
    const [selectedBirthCityOption, setSelectedBirthCityOption] = useState(null);
    const [isBirthCityLoading, setIsBirthCityLoading] = useState(false);
    const [valueBirthCountry, setValueBirthCountry] = useState("");
    const [resultBirthCountry, setResultBirthCountry] = useState(null);
    const [selectedBirthCountryOption, setSelectedBirthCountryOption] = useState(null);
    const [isBirthCountryLoading, setIsBirthCountryLoading] = useState(false);
    
    // const timeoutRefBirthCity = useRef(null);
    // const timeoutRefBirthCountry = useRef(null);
    const birthCityRequestIdRef = useRef(0);
    const birthCountryRequestIdRef = useRef(0);

    const [personFormData, setPersonFormData] = useState({
            situationChangeReason: '',
            departureDate: '',
            deceaseDate: '',
            householdRelation: '',
            taxDeclarant: '',
            civility: '',
            firstname: '',
            lastname: '',
            birtCountry: '',
            birthCity: '',
            nationalityPerCategory: '',
            taxDependent: '',
            taxDependentApartFromHome: '',
            custodyRights: '',
            visitationRights: '',
            householdLink: '',
            disabilityStatus: '',
            familySituation: '',
            familySituationDate: ''
        });

    const yesNoOptions = [
        {
            code: "",
            label: ""
        },
        {
            code: "true",
            label: "Oui"
        },
        {
            code: "false",
            label: "Non"
        },
    ]

    useEffect(() => {
        if (selectedPerson && open) {
            const initialData = {
                situationChangeReason: selectedPerson?.situationChangeReason || '',
                departureDate: selectedPerson?.departureDate || '',
                deceaseDate: selectedPerson?.deceaseDate || '',
                householdRelation: selectedPerson?.householdRelation || '',
                taxDeclarant: selectedPerson?.taxDeclarant || '',
                civility: selectedPerson?.civility || '',
                firstname: selectedPerson?.firstname || '',
                lastname: selectedPerson?.lastname || '',
                maidenName: selectedPerson?.maidenName || '',
                birthCountry: selectedPerson?.birthCountry || '',
                birthCity: selectedPerson?.birthCity || '',
                nationalityPerCategory: selectedPerson?.nationalityPerCategory || '',
                taxDependent: selectedPerson?.taxDependent || '',
                taxDependentApartFromHome: selectedPerson?.taxDependentApartFromHome || '',
                custodyRights: selectedPerson?.custodyRights || '',
                visitationRights: selectedPerson?.visitationRights || '',
                householdLink: selectedPerson?.householdLink || '',
                disabilityStatus: selectedPerson?.disabilityStatus || '',
                familySituation: selectedPerson?.familySituation || '',
                familySituationDate: selectedPerson?.familySituationDate || ''
            };

            setInitialPersonData(initialData);
            setPersonFormData(initialData);
            setValueBirthCountry(selectedPerson?.birthCountry || '');
            setValueBirthCity(selectedPerson?.birthCity || '');
            setSelectedBirthCountryOption(null);
            setSelectedBirthCityOption(null);
            setResultBirthCountry(null);
            setResultBirthCity(null);
        }
    }, [selectedPerson, open]);

    function birthCityAutocomplete(city) {
        if (!city || city.trim().length < 2) {
            setResultBirthCity(null);
            setIsBirthCityLoading(false);
            return;
        }

        const requestId = ++birthCityRequestIdRef.current;
        setIsBirthCityLoading(true);

        onlineProcessesService.findCity(city)
            .then((result) => {
                if (requestId !== birthCityRequestIdRef.current) return;
                setResultBirthCity(Array.isArray(result) ? result : []);
            })
            .catch(err => {
                if (requestId !== birthCityRequestIdRef.current) return;
                console.error(err);
                setResultBirthCity(null);
            })
            .finally(() => {
                if (requestId !== birthCityRequestIdRef.current) return;
                setIsBirthCityLoading(false);
            });
    }

    function birthCountryAutocomplete(country) {
        if (!country || country.trim().length < 2) {
            setResultBirthCountry(null);
            setIsBirthCountryLoading(false);
            return;
        }

        const requestId = ++birthCountryRequestIdRef.current;
        setIsBirthCountryLoading(true);

        onlineProcessesService.findCountry(country)
            .then((result) => {
                if (requestId !== birthCountryRequestIdRef.current) return;
                setResultBirthCountry(Array.isArray(result) ? result : []);
            })
            .catch(err => {
                if (requestId !== birthCountryRequestIdRef.current) return;
                console.error(err);
                setResultBirthCountry(null);
            })
            .finally(() => {
                if (requestId !== birthCountryRequestIdRef.current) return;
                setIsBirthCountryLoading(false);
            });
    }

    useEffect(() => {
        if (valueBirthCountry && valueBirthCountry.length > 1) {
            birthCountryAutocomplete(valueBirthCountry);
        } else {
            setResultBirthCountry(null);
            setIsBirthCountryLoading(false);
        }
    }, [valueBirthCountry]);

    useEffect(() => {
        if (valueBirthCity && valueBirthCity.length > 1) {
                birthCityAutocomplete(valueBirthCity);
            setResultBirthCity(null);
            setIsBirthCityLoading(false);
        }
    }, [valueBirthCity]);

    
    function handleClose() {
        setOpen(false);
    };

        function addEmptyOption(options) {
        if (!options || options.length === 0) {
            return [{ code: "", label: "" }];
        }
        const hasEmptyOption = options.some(opt => opt.code === "" || opt.code === null);
        if (hasEmptyOption) {
            return options;
        }
        return [{ code: "", label: "" }, ...options];
    };

    function handleField(fieldName, value) {
        setPersonFormData(formData => ({
            ...formData,
            [fieldName]: value?.code || value,
        }))
    }

    function getOptions(ref) {
        if (typeof ref === 'string') {
            const options = mapReferenceToOptions(ref);
            return addEmptyOption(options);
        } else {
            return (ref)
        }
    }

    function getValue(value, ref){
        const result = getOptions(ref);
        const dataTable = Array.isArray(result) && result.length ? result : ref;
        return (
            dataTable.find(
                option => option.code === value
            ) ?? null
        )
    };

    function getBirthCountryPlaceholder() {
        if (isBirthCountryLoading) {
            return 'Recherche de pays...';
        }
        if (valueBirthCountry?.trim()?.length > 1 && resultBirthCountry?.length === 0) {
            return "Aucun pays n'a été trouvé";
        }
        return 'Tapez pour rechercher...';
    }

    function getBirthCityPlaceholder() {
        if (isBirthCityLoading) {
            return 'Recherche de ville...';
        }
        if (valueBirthCity?.trim()?.length > 1 && resultBirthCity?.length === 0) {
            return "Aucune ville n'a été trouvée";
        }
        return 'Tapez pour rechercher...';
    }

    function formatReadonlyValue(value) {
        if (value === null || value === undefined) {
            return '';
        }

        if (typeof value === 'object') {
            return value.label || value.name || value.code || '';
        }

        return value;
    }

    function formatDate(dateValue) {
        if (!dateValue) return '';

        const str = String(dateValue).trim();

        const isoMatch = str.match(/^(\d{4})-(\d{2})-(\d{2})/);
        if (isoMatch) {
            const [, yyyy, mm, dd] = isoMatch;
            return `${dd}/${mm}/${yyyy}`;
        }

        return str;
    }

    const readonlyFields = [
        {
            label: 'Motif de départ',
            value: getValue(personFormData.situationChangeReason, "PERSON_RECORD_SITUATION_CHANGE_REASON_IMPORT")
        },
        {
            label: 'Date de départ',
            value: formatDate(personFormData.departureDate)
        },
        {
            label: 'Date de décès',
            value: formatDate(personFormData.deathDate)
        },
        {
            label: 'Déclarant fiscal principal',
            value: getValue(personFormData.taxDeclarant, yesNoOptions).label
        },
        {
            label: 'Parent fiscal',
            value: personFormData?.taxDeclarant !== "true"
                ? getValue(personFormData.householdRelation, "PERSON_RECORD_HOUSE_HOLD_LINK")
                : null
        },
        {
            label: 'Civilité',
            value: getValue(personFormData.civility, "PERSON_RECORD_TITLE")
        },
        {
            label: 'Prénom',
            value: personFormData.firstname
        },
        {
            label: 'Nom',
            value: personFormData.lastname
        },
        {
            label: 'Nom de naissance',
            value: personFormData.maidenName
        },
        {
            label: 'Nationalité',
            value: getValue(personFormData.nationalityPerCategory, "PERSON_RECORD_NATIONALITY_PER_CATEGORY")
        },
        {
            label: 'Pays de naissance',
            value: valueBirthCountry
        },
        {
            label: 'Ville de naissance',
            value: valueBirthCity
        },
        {
            label: 'État matrimonial',
            value: getValue(personFormData.familySituation, "PERSON_RECORD_FAMILY_SITUATION")
        },
        {
            label: 'Date de changement',
            value: formatDate(personFormData.familySituationDate)
        },
        {
            label: 'À charge',
            value: getValue(personFormData.taxDependent, "PERSON_RECORD_TAX_DEPENDENT")
        },
        {
            label: 'À charge personne hors foyer',
            value: getValue(personFormData.taxDependentApartFromHome, "PERSON_RECORD_TAX_DEPENDENT_APART_FROM_HOME")
        },
        {
            label: 'Droit de visite',
            value: getValue(personFormData.visitationRights, "PERSON_RECORD_VISITATION_RIGHTS")
        },
        {
            label: 'Lien de parenté',
            value: getValue(personFormData.householdLink, "PERSON_RECORD_HOUSE_HOLD_LINK")
        },
        {
            label: 'Situation de handicap',
            value: getValue(personFormData.disabilityStatus, "PERSON_RECORD_DISABILITY_STATUS")
        },
    ];

    function createJsonPatch(personData) {
        const patches = [];

        Object.keys(personData).forEach(key => {
            const currentValue = personData[key];
            const initialValue = initialPersonData[key];
            const specialKeysMap = {
                birthCity: selectedBirthCityOption,
                birthCountry: selectedBirthCountryOption
            };
            
            if (currentValue !== initialValue) {
                if(specialKeysMap[key]?.id && (specialKeysMap[key].name === currentValue || specialKeysMap[key].id === currentValue)){
                    patches.push({
                        op: "replace",
                        path: `${key}Insee`,
                        value: specialKeysMap[key].id || ''
                    });
                }else{
                    patches.push({
                        op: "replace",
                        path: `${key}`,
                        value: currentValue || ''
                    });
                }
            }
        });

        return patches;
    }

    function formCheck() {
    const hasAnyValue = personFormData.situationChangeReason || 
                        personFormData.departureDate || 
                        personFormData.deathDate;
    if (!hasAnyValue) {
        return true;
    }
    if (personFormData.situationChangeReason && !personFormData.departureDate) {
        quadralToast.error("Veuillez renseigner la date de départ");
        return false;
    }

    if (personFormData.departureDate && !personFormData.situationChangeReason) {
        quadralToast.error("Veuillez sélectionner un motif de changement de situation");
        return false;
    }

    if ((personFormData.situationChangeReason === "deces" || 
         personFormData.situationChangeReason?.code === "deces")) {
        if (!personFormData.deathDate) {
            quadralToast.error("Veuillez renseigner la date de décès");
            return false;
        }
        if (!personFormData.departureDate) {
            quadralToast.error("Veuillez renseigner la date de départ");
            return false;
        }
    }

    if (personFormData.deathDate) {
        if (!personFormData.situationChangeReason) {
            quadralToast.error("Veuillez sélectionner le motif 'Décès'");
            return false;
        }
        if (personFormData.situationChangeReason !== "deces" && 
            personFormData.situationChangeReason?.code !== "deces") {
            quadralToast.error("Si vous indiquez une date de décès, le motif doit être 'Décès'");
            return false;
        }
        if (!personFormData.departureDate) {
            quadralToast.error("Veuillez renseigner la date de départ");
            return false;
        }
    }

    return true;
}

    async function handleConfirm() {
        if (!selectedPerson) return;

        if(!formCheck()) return;

        const personDataForPatch = {
            ...personFormData,
            birthCountry: valueBirthCountry,
            birthCity: valueBirthCity
        };

        const jsonPatch = createJsonPatch(personDataForPatch);

        if (jsonPatch.length === 0) {
            setOpen(false);
            return;
        }

        showLoader();
        setLoader && setLoader(true);

        try {
            await onlineProcessesService.patchPersonRecord(
                participation.id,
                selectedPerson.id,
                jsonPatch
            );

            if (props.refreshPersonsData) {
                await props.refreshPersonsData();
            }

            quadralToast.success("Fiche personne mise à jour avec succès");
            setOpen(false);

        } catch (error) {
            console.error("Erreur lors de la mise à jour de la personne : ", error);
            quadralToast.error("Erreur lors de la mise à jour de la personne");
        } finally {
            hideLoader();
            setLoader && setLoader(false);
        }
    }
    
    return(
        <QuadralModal
            size='XL'
            title='Modifier le membre du foyer'
            subtitle={selectedPerson?.personRecordName}
            icon={<FontAwesomeIcon icon={faUserPen}/>}
            open={open}
            setOpen={setOpen}
            noButton
            action={
                <>
                    <QuadralButton 
                        size="medium"
                        color="secondary"
                        label={isN3 ? "Fermer" : "Annuler"}
                        onClick={() => handleClose()}
                    />
                {!isN3 && (
                    <QuadralButton 
                        size="medium" 
                        startIcon={<FontAwesomeIcon icon={faFloppyDisk}/>}
                        label='Enregistrer'
                        onClick={() => handleConfirm()}
                    />
                )}
                </>
            }
        >

            <QuadralForm>
                {isN3 ? (
                    <Grid container spacing="15px">
                        {readonlyFields.map((item) => {
                            const displayValue = formatReadonlyValue(item.value);
                            return (
                                <Grid
                                    key={item.label}
                                    sx={{padding: '0.5rem 1rem', display:'flex', flexDirection:'column'}}
                                    size={{md: 3, sm: 4, xs: 6}}
                                >

                                    <QuadralTypography variant='dataLabel'>{item.label}</QuadralTypography>
                                    {(displayValue && displayValue !== 'undefined' && displayValue !== 'inconnu') ? (
                                        <QuadralTypography sx={{wordBreak: 'break-word'}} variant='dataValue'>{displayValue}</QuadralTypography>
                                    ) : (
                                        <QuadralTypography sx={{wordBreak: 'break-word', textTransform:'none'}} variant='dataLabel'>Non renseigné</QuadralTypography>
                                    )}
                                </Grid>
                            )})}
                    </Grid>
                ) : (
                    <>
                <QuadralAutocomplete 
                    id="situationChangeReason"
                    label='Motif de départ'
                    value={getValue(personFormData.situationChangeReason, "PERSON_RECORD_SITUATION_CHANGE_REASON_IMPORT")}
                    options={getOptions("PERSON_RECORD_SITUATION_CHANGE_REASON_IMPORT")}
                    getOptionLabel={(option) => option.label}
                    onChange={(e, value) => handleField('situationChangeReason', value)}
                    required={(
                        personFormData.situationChangeReason !== '' && personFormData.situationChangeReason !== null) ||
                        personFormData.departureDate || 
                        personFormData.deathDate}
                />
                <QuadralDate 
                    id='departureDate'
                    label="Date de départ"
                    value={personFormData.departureDate}
                    onChange={(date) => handleField('departureDate', date?.format('YYYY-MM-DD'))}
                    required={
                        (personFormData.departureDate !== '' && personFormData.departureDate !== null) ||
                        personFormData.situationChangeReason || 
                        personFormData.deathDate}
                />
                <QuadralDate 
                    id='deceaseDate'
                    label="Date de décès"
                    value={personFormData.deathDate}
                    onChange={(date) => handleField('deathDate', date?.format('YYYY-MM-DD'))}
                    required={
                        (personFormData.deathDate !== '' && personFormData.deathDate !== null) ||
                        personFormData.situationChangeReason === "deces" ||
                        personFormData.situationChangeReason?.code === "deces"}
                />
                <QuadralAutocomplete 
                    id="taxDeclarant" 
                    label='Déclarant fiscal principal'
                    value={getValue(personFormData.taxDeclarant, yesNoOptions)}
                    options={yesNoOptions}
                    getOptionLabel={(option) => option.label}
                    onChange={(e, value) => handleField('taxDeclarant', value)}
                />
                {personFormData?.taxDeclarant !== "true" && (
                    <QuadralAutocomplete 
                        id="householdRelation" 
                        label='Parent fiscal'
                        value={getValue(personFormData.householdRelation, "PERSON_RECORD_HOUSE_HOLD_LINK")}
                        options={getOptions("PERSON_RECORD_HOUSE_HOLD_LINK")}
                        getOptionLabel={(option) => option.label}
                        onChange={(e, value) => handleField('householdRelation', value)}
                    />
                )}
                <QuadralAutocomplete 
                    id="civility" 
                    label='Civilité'
                    value={getValue(personFormData.civility, "PERSON_RECORD_TITLE")}
                    options={getOptions("PERSON_RECORD_TITLE")}
                    getOptionLabel={(option) => option.label}
                    onChange={(e, value) => handleField('civility', value)}
                />
                <QuadralTextField 
                    id="firstname" 
                    label='Prénom'
                    value={personFormData.firstname}
                    onChange={(value) => {handleField('firstname', value)}}
                />
                <QuadralTextField 
                    id="lastname" 
                    label='Nom'
                    value={personFormData.lastname}
                    onChange={(value) => {handleField('lastname', value)}}
                />
                <QuadralTextField 
                    id="maidenName" 
                    label='Nom de naissance'
                    value={personFormData.maidenName}
                    onChange={(value) => {handleField('maidenName', value)}}
                />
                <QuadralAutocomplete 
                    id="nationalityPerCategory" 
                    label='Nationalité'
                    value={getValue(personFormData.nationalityPerCategory, "PERSON_RECORD_NATIONALITY_PER_CATEGORY")}
                    options={getOptions("PERSON_RECORD_NATIONALITY_PER_CATEGORY")}
                    getOptionLabel={(option) => option.label}
                    onChange={(e, value) => handleField('nationalityPerCategory', value)}
                />
                <QuadralAutocomplete
                    id="birthCountry" 
                    label='Pays de naissance'
                    value={valueBirthCountry}
                    options={resultBirthCountry?.map((option) => option.name) || []}
                    loading={isBirthCountryLoading}
                    placeholder={getBirthCountryPlaceholder()}
                    noOptionsText={isBirthCountryLoading ? 'Recherche de pays...' : "Aucun pays n'a été trouvé"}
                    loadingText='Recherche de pays...'
                    onInputChange={(event, newInputValue, reason) => {
                        if (reason && reason !== 'input') return;
                        setValueBirthCountry(newInputValue || "");
                        setSelectedBirthCountryOption(null);
                    }}
                    onChange={(event, newValue) => {
                        const selectedName = newValue || "";
                        const selectedOption = resultBirthCountry?.find((option) => option.name === selectedName) || null;
                        setValueBirthCountry(selectedName);
                        setSelectedBirthCountryOption(selectedOption);
                    }}
                />
                <QuadralAutocomplete
                    id="birthCity"
                    label='Ville de naissance'
                    value={valueBirthCity}
                    options={resultBirthCity?.map((option) => option.name) || []}
                    loading={isBirthCityLoading}
                    placeholder={getBirthCityPlaceholder()}
                    noOptionsText={isBirthCityLoading ? 'Recherche de ville...' : "Aucune ville n'a été trouvée"}
                    onInputChange={(event, newInputValue, reason) => {
                        if (reason && reason !== 'input') return;
                        setValueBirthCity(newInputValue || "");
                        setSelectedBirthCityOption(null);
                    }}
                    onChange={(event, newValue) => {
                        const selectedName = newValue || "";
                        const selectedOption = resultBirthCity?.find((option) => option.name === selectedName) || null;
                        setValueBirthCity(selectedName);
                        setSelectedBirthCityOption(selectedOption);
                    }}
                />
                <QuadralAutocomplete 
                    id="familySituation" 
                    label='État matrimonial'
                    value={getValue(personFormData.familySituation, "PERSON_RECORD_FAMILY_SITUATION")}
                    options={getOptions("PERSON_RECORD_FAMILY_SITUATION")}
                    getOptionLabel={(option) => option.label}
                    onChange={(e, value) => handleField('familySituation', value)}
                />
                <QuadralDate 
                    id='familySituationDate'
                    label="Date de changement"
                    value={personFormData.familySituationDate}
                    onChange={(date) => handleField('familySituationDate', date?.format('YYYY-MM-DD'))}
                />
                <QuadralAutocomplete 
                    id="taxDependent" 
                    label="À charge"
                    value={getValue(personFormData.taxDependent, "PERSON_RECORD_TAX_DEPENDENT")}
                    options={getOptions("PERSON_RECORD_TAX_DEPENDENT")}
                    getOptionLabel={(option) => option.label}
                    onChange={(e, value) => handleField('taxDependent', value)}
                />
                <QuadralAutocomplete 
                    id="taxDependentApartFromHome" 
                    label="À charge personne hors foyer"
                    value={getValue(personFormData.taxDependentApartFromHome, "PERSON_RECORD_TAX_DEPENDENT_APART_FROM_HOME")}
                    options={getOptions("PERSON_RECORD_TAX_DEPENDENT_APART_FROM_HOME")}
                    getOptionLabel={(option) => option.label}
                    onChange={(e, value) => handleField('taxDependentApartFromHome', value)}
                />
                <QuadralAutocomplete 
                    id="visitationRights" 
                    label="Droit de visite"
                    value={getValue(personFormData.visitationRights, "PERSON_RECORD_VISITATION_RIGHTS")}
                    options={getOptions("PERSON_RECORD_VISITATION_RIGHTS")}
                    getOptionLabel={(option) => option.label}
                    onChange={(e, value) => handleField('visitationRights', value)}
                />
                <QuadralAutocomplete 
                    id="householdLink" 
                    label="Lien de parenté"
                    value={getValue(personFormData.householdLink, "PERSON_RECORD_HOUSE_HOLD_LINK")}
                    options={getOptions("PERSON_RECORD_HOUSE_HOLD_LINK")}
                    getOptionLabel={(option) => option.label}
                    onChange={(e, value) => handleField('householdLink', value)}
                />
                <QuadralAutocomplete 
                    id="disabilityStatus" 
                    label="Situation de handicap"
                    value={getValue(personFormData.disabilityStatus, "PERSON_RECORD_DISABILITY_STATUS")}
                    options={getOptions("PERSON_RECORD_DISABILITY_STATUS")}
                    getOptionLabel={(option) => option.label}
                    onChange={(e, value) => handleField('disabilityStatus', value)}
                />
                    </>
                )}
            </QuadralForm>
        </QuadralModal>
    )
}

export default UpdatePersonModal;